// Dependencies
import Backbone from 'backbone';
import Handlebars from 'handlebars';
import EventHub from '~/eventHub';

// Services
import getReportSuperCategoryService from '~/services/report/reportSuperCategoryService';

// Handlebars
import template from '~/templates/report/conferencista.handlebars';

var ConferencistaView = Backbone.View.extend({
    className: 'conferencistaView',

    initialize: function() {
      $('.region-content-row').css('background','url("images/new/fondo.jpg") no-repeat center');
      $('.region-content-row').css('background-size','cover');
      $.get("images/new/fondo-conferencista.jpg").done(function () {
  			$('.region-content-row').css('background','url("images/new/fondo-conferencista.jpg") no-repeat center');
  			$('.region-content-row').css('background-size','cover');
  		});
    },

    events: {
        'click .btnhome': 'home',
		'click .btnback': 'back'
    },

     translate: function(e){
       var that = this;
       var callback = data => {
         if(arrlang[lang] === undefined){ return }
         that.$el.find('.item').each(function(index, element){
           $(this).text(arrlang[lang][$(this).attr("key")]);
         });
       }
       if(Object.keys(window.arrlang).length !== 0){
         callback();
       }
       this.listenTo(EventHub, 'translation', callback);
    },

    render: function() {
		var handlebarsTemplate = Handlebars.template(template);
		this.$el.html(handlebarsTemplate());
		this.listenTo(EventHub, 'conferencista:setState', data => {
			if (data.conferencistaID) {
				this.renderConferencista(data.conferencistaID);
			}
		});
      this.translate();
      return this;
    },

	renderConferencista: function(conferencistaID){
		var superCategoryPromise = getReportSuperCategoryService().fetch({
          all: true,
          cache: false,
          rules: {
            equals: [{
                key: 'objectId',
                val: conferencistaID
            }]
          }
        }).then(conferencista => {
			var handlebarsTemplate = Handlebars.template(template);
			window.spinnerDialog.hide();
			conferencista.models[0].attributes.name = conferencista.models[0].attributes.name.replace(/\n/g, "<br>");
			conferencista.models[0].attributes.description = conferencista.models[0].attributes.description.replace(/\n/g, "<br>");
			var conferencistaText = '<img class="conferencista-img" src="'+conferencista.models[0].attributes.image._url+'"><p class="name">'+conferencista.models[0].attributes.name+'</p><p>'+conferencista.models[0].attributes.description+'</p>';
            this.$el.html(handlebarsTemplate());
            this.translate();
			this.$el.find('#conferencista').html(conferencistaText);
        });
	},

	home: function() {
        EventHub.trigger('navigate', 'login', {
            trigger: true
        });
    },

	back: function(){
		 EventHub.trigger('navigate', 'conferencistas', {
            trigger: true
        });
	}
});
export default ConferencistaView;
